import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeGetCustomerResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeCustomerParamsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeCustomerParamsSchema>
type Response = DataResponseWithPagination<z.infer<typeof BackofficeGetCustomerResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

const getBackofficeCustomerQueryKey = (query: Query) => ["backofficeCustomer", query]

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeCustomerQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeCustomerQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/customers/${query.id}`)
      onSuccess?.(data)
      return data.data
    },
  })
}
